<template>
  <v-row>
    <v-col cols="12">
      <div id="dados-concessao">
        <v-simple-table dense class="ma-1 pa-1">
          <template v-slot:default>
            <tbody>
              <tr title="Área de Concessão">
                <td class="caption font-weight-regular ma-1 ml-8 pa-1">Área</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ areaConcessao }} km²</span>
                </td>
              </tr>
              <tr title="Qtde de Consumidores">
                <td class="caption font-weight-regular ma-1 pa-1">Consumidores</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ numConsumidores }}
                  </span>
                </td>
              </tr>
              <tr title="Km de Rede MT">
                <td class="caption font-weight-regular ma-1 pa-1">Rede MT</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ kmRedeMT }} km</span>
                </td>
              </tr>
              <tr title="Km de Rede BT">
                <td class="caption font-weight-regular ma-1 pa-1">Rede BT</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>{{ kmRedeBT }} km</span>
                </td>
              </tr>
              <tr title="Qtde de Subestações">
                <td class="caption font-weight-regular ma-1 pa-1">Subestações</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ qtdSubestacoes }}
                  </span>
                </td>
              </tr>
              <tr title="Qtde de Conjuntos">
                <td class="caption font-weight-regular ma-1 pa-1">Conjuntos</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ qtdConjuntos }}
                  </span>
                </td>
              </tr>
              <tr title="Qtde de Municípios">
                <td class="caption font-weight-regular ma-1 pa-1">Municípios</td>
                <td class="caption font-weight-regular ma-1 pa-1">
                  <v-progress-circular
                    v-if="carregando"
                    indeterminate
                    :color="progress.color"
                    :size="progress.size"
                    :width="progress.width"
                  />
                  <span v-else>
                    {{ qtdMunicipiosAtendidos }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import DadosAreaConcessaoService from '@/services/DadosAreaConcessaoService.js';

  export default {
    data() {
      return {
        carregando: true,
        arat: {
          area_concessao_km2: 0,
          num_consumidores: 0,
          km_rede_mt: 0,
          km_rede_bt: 0,
          qtd_subestacoes: 0,
          qtd_conjuntos: 0,
          qtd_municipios_atendidos: 0
        },
        progress: {
          color: 'black',
          size: 20,
          width: 1
        }
      };
    },
    computed: {
      empresa() {
        return this.$store.getters.getEmpresa;
      },
      areaConcessao() {
        return this.formatNumber(this.arat.area_concessao_km2, 2);
      },
      numConsumidores() {
        return this.formatNumber(this.arat.num_consumidores);
      },
      kmRedeMT() {
        return this.formatNumber(this.arat.km_rede_mt, 2);
      },
      kmRedeBT() {
        return this.formatNumber(this.arat.km_rede_bt, 2);
      },
      qtdSubestacoes() {
        return this.formatNumber(this.arat.qtd_subestacoes);
      },
      qtdConjuntos() {
        return this.formatNumber(this.arat.qtd_conjuntos);
      },
      qtdMunicipiosAtendidos() {
        return this.formatNumber(this.arat.qtd_municipios_atendidos);
      }
    },
    mounted() {
      this.getArat();
    },
    methods: {
      formatNumber(number, maximumFractionDigits = 0) {
        return new Intl.NumberFormat('pt-BR', { maximumFractionDigits }).format(number || 0);
      },
      getArat() {
        DadosAreaConcessaoService.getDados()
          .then(({ data }) => {
            if (data && data.data && data.data.dados_area_concessao) this.arat = JSON.parse(data.data.dados_area_concessao);
          })
          .finally(() => (this.carregando = false));
      }
    }
  };
</script>

<style scoped>
  #dados-concessao {
    min-height: 300px;
    max-height: 300px;
    z-index: 0;
  }
</style>
